import { defineStore } from "pinia";
import { http } from "./https";
import cache from '@/cache';

export const useNewGamesStore = defineStore("new-games", {
  state: () => ({
    games: [],
    nextPage: 1,
    isLoaded: false,
  }),
  actions: {
    // Reset pagination for fresh loads
    resetPagination() {
      this.nextPage = 1;
      this.games = [];
      this.isLoaded = false;
    },
    async loadLatestGames(forceRefresh = false) {
      try {
        if(this.nextPage == null){
          return;
        }
        
        const cacheKey = 'new_games_page_1';
        
        // For first page, try cache first
        if (this.nextPage === 1 && !forceRefresh) {
          const cachedData = cache.get(cacheKey);
          if (cachedData) {
            this.nextPage = cachedData.nextPage;
            this.games = cachedData.games;
            this.isLoaded = true;
            return true;
          }
        }
        
        const response = await http.get(`/games/latest?page=`+this.nextPage);
        const data = response.data;

        const previousPage = this.nextPage;
        this.nextPage = data.next_page_number;
        this.games = this.games.concat(data.games);
        this.isLoaded = true;
        
        // Cache first page only
        if (previousPage === 1) {
          cache.set(cacheKey, {
            nextPage: this.nextPage,
            games: this.games,
          }, 'games');
        }

        return true;
      } catch (error) {
        console.error(error);
      }
      return false;
    },
  },
});
